var giftPayment = {
    version: '1.0',
    author: 'CAA Digital',
    project: 'Gift membership',
    Date: 'Sep 2020',

    //initialization 
    init: function () {
        var context = this;
        //Global variables
        context.config = {

        };

        //Call DOM invoking functions here
        context.onDomReady();
        context.eventHandlers();

    },

    onDomReady: function () {
        var context = this;
        //Load all functions
        //Recurring copy show hide 
        context.recurringCopyDisplay = function (copy, checkbox) {
                if (copy && checkbox) {
                    if (checkbox.checked) {
                        copy.classList.remove("d-none");
                        context.setAttributes(copy, {
                            "tabindex": "-1",
                            "aria-atomic": "true",
                            "aria-live": "assertive"
                        });
                    } else {
                        copy.classList.add("d-none");
                    }
                }
            },

            //Setting up multiple attributes 
            context.setAttributes = function (el, attrs) {
                for (var key in attrs) {
                    el.setAttribute(key, attrs[key]);
                }
            },

            //show hide card on file 
            context.cardOnFile = function (checkbox, cardOnFileBlock, creditCard) {
                if (checkbox) {
                    if (checkbox.checked == true) {
                        cardOnFileBlock.classList.remove("d-none");
                        creditCard.classList.add("d-none");
                        context.setAttributes(cardOnFileBlock, {
                            "tabindex": "-1",
                            "aria-atomic": "true",
                            "aria-live": "assertive"
                        });

                    } else {
                        cardOnFileBlock.classList.add("d-none");
                        creditCard.classList.remove("d-none");
                    }
                }
            }

    },

    //Handle all page level events
    eventHandlers: function () {
        var context = this,
            recurringCheckbox = document.querySelector("#recurring"),
            recurringCopy = document.querySelector(".recurring__copy"),
            carOnfileCheckbox = document.querySelector("#card_on_file"),
            paymentDisplay = document.querySelector(".payment__display"),
            paymentFields = document.querySelector(".payment__fields");

        if (recurringCheckbox) {
            recurringCheckbox.addEventListener("click", function () {
                context.recurringCopyDisplay(recurringCopy, recurringCheckbox);
            });
        }
        if (carOnfileCheckbox) {
            carOnfileCheckbox.addEventListener("click", function () {
                context.cardOnFile(carOnfileCheckbox, paymentDisplay, paymentFields);
            });
        }

        //On window load
        context.recurringCopyDisplay(recurringCopy, recurringCheckbox);
        context.cardOnFile(carOnfileCheckbox, paymentDisplay, paymentFields);
    },
};

window.addEventListener("load", function () {
    giftPayment.init();
});